import React from "react";
import { Container, Row, Col, Card, Badge } from "react-bootstrap";
import AppNavbar from "../../../components/common/AppNavbar";

const USVisaReforms2026 = () => {
  return (
    <>
      <AppNavbar />
      <div style={{ background: "#f4f7fb" }}>
        {/* HERO SECTION */}
        <div
          style={{
            background: "linear-gradient(135deg, #0f2027, #203a43, #2c5364)",
            color: "white",
            padding: "60px 0",
          }}
        >
          <Container>
            <Badge bg="warning" text="dark" className="mb-3">
              Immigration Update July 2026
            </Badge>
            <h1 className="fw-bold">
              US Plans Tougher H-1B and Green Card Rules From August
            </h1>
            <p className="lead mt-3" style={{ maxWidth: "900px" }}>
              A fresh round of federal rulemaking could reshape H-1B
              sponsorship, PERM labor certification, student visas, and H-4
              spouse work permits — with Indian professionals and students
              expected to be among the most affected.
            </p>
          </Container>
        </div>

        <section className="immigration-article">
          <div className="container pt-4">
            <h2>US Immigration Overhaul: What's Changing From August 2026</h2>

            <p>
              The Trump administration is preparing a broad set of immigration
              rule changes spanning the H-1B visa program, PERM labor
              certification, international student status, and Employment
              Authorization Documents (EADs) for H-4 spouses. The proposals
              appear in the latest Unified Regulatory Agendas released jointly
              by the Departments of Homeland Security (DHS), Labor (DOL), and
              State (DOS).
            </p>

            <p>
              None of the measures has been enacted yet, and each must still
              pass through formal rulemaking — including publication of draft
              rules, a public comment period, and final approval. Even so,
              immigration attorneys describe the agendas as a clear roadmap of
              where the administration intends to take US immigration policy
              over the coming year.
            </p>

            <hr />

            <h3>H-1B Visa Program: Tighter Rules Expected in August</h3>

            <p>
              DHS is expected to publish a proposed rule in{" "}
              <strong>August 2026</strong> tightening several parts of the H-1B
              program, which issues <strong>85,000 new visas</strong> annually
              under the annual cap.
            </p>

            <h4>Key Proposed H-1B Changes</h4>
            <ul>
              <li>
                <strong>Narrower cap exemptions</strong> for universities and
                nonprofit research organizations that currently sit outside the
                annual quota.
              </li>
              <li>
                <strong>Stricter third-party placement rules</strong> for
                employers who station H-1B workers at client sites, a staffing
                model widely used by Indian IT and consulting firms — likely
                requiring proof of a genuine employer-employee relationship and
                stronger documentation of work assignments.
              </li>
              <li>
                <strong>Increased scrutiny of employers</strong> with a history
                of H-1B compliance violations.
              </li>
              <li>
                A possible{" "}
                <strong>extension of the existing supplemental fee</strong> on
                large employers to cover visa extension applications as well as
                new petitions.
              </li>
            </ul>

            <hr />

            <h3>PERM Labor Certification and Prevailing Wage Overhaul</h3>

            <p>
              The Department of Labor is planning to raise the prevailing wage
              levels used in both H-1B petitions and PERM labor certification
              cases, the first step in most employer-sponsored Green Card
              applications.
            </p>

            <h4>What Would Change</h4>
            <ul>
              <li>
                The <strong>entry-level wage threshold</strong> would rise from
                the <strong>17th percentile to the 34th percentile</strong>,
                with higher wage tiers adjusted upward as well.
              </li>
              <li>
                Employers would need to offer significantly{" "}
                <strong>higher minimum salaries</strong> to sponsor foreign
                workers, raising the overall cost of Green Card sponsorship.
              </li>
              <li>
                The PERM process itself would see{" "}
                <strong>updated recruitment standards</strong>, revised rules on
                layoffs of US workers, and stronger anti-discrimination
                provisions.
              </li>
            </ul>

            <p>
              Amid already lengthy Green Card backlogs, some skilled
              professionals are reportedly exploring alternative destinations,
              including the United Kingdom, where permanent residency pathways
              are seen as more predictable.
            </p>

            <hr />

            <h3>International Students: End of "Duration of Status"</h3>

            <p>
              DHS intends to replace the long-standing{" "}
              <strong>"duration of status"</strong> system, under which students
              can remain in the US for as long as they meet their academic
              program's requirements, with a{" "}
              <strong>fixed period of authorized stay</strong>. Once that period
              ends, students would need to apply for an extension to continue
              studying or remain in the country.
            </p>

            <p>
              A separate proposal targeting{" "}
              <strong>Optional Practical Training (OPT)</strong> — including the
              two-year STEM OPT extension and Curricular Practical Training
              (CPT) — is expected around <strong>February 2027</strong>.
            </p>

            <p>
              India sent roughly <strong>3.6 lakh students</strong> to the US
              during the 2024–25 academic year, making it the largest source of
              international students in the country, so any tightening of
              student status rules would carry outsized weight for Indian
              applicants.
            </p>

            <hr />

            <h3>H-4 Spouse Work Permits Face Renewal Risk</h3>

            <p>
              Planned changes to Employment Authorization Documents could
              particularly affect <strong>H-4 visa holders</strong>, many of
              whom are spouses of H-1B workers awaiting employment-based Green
              Cards — a group in which Indians make up a large share.
            </p>

            <p>
              H-4 EAD holders can currently apply for renewal only up to{" "}
              <strong>180 days before expiry</strong>. If automatic extensions
              are curtailed and USCIS processing times remain long, many spouses
              could face a gap in legal work authorization even after filing
              renewals on time.
            </p>

            <hr />

            <h3>Summary</h3>

            <h4>For Skilled Workers and Employers:</h4>
            <ul>
              <li>Higher sponsorship costs via increased prevailing wages</li>
              <li>
                Narrower H-1B cap exemptions and tighter third-party placement
                rules
              </li>
              <li>
                Greater scrutiny for employers with past compliance issues
              </li>
            </ul>

            <h4>For Students and H-4 Spouses:</h4>
            <ul>
              <li>
                Fixed-period student status replacing open-ended duration of
                status
              </li>
              <li>Upcoming review of OPT and CPT work-authorization rules</li>
              <li>
                Possible work authorization gaps for H-4 EAD holders during
                renewal
              </li>
            </ul>

            <p>
              None of these proposals has taken effect yet, but taken together
              they signal the administration's intent to tighten nearly every
              major pathway Indian professionals and students use to study and
              work in the United States.
            </p>
          </div>
        </section>
      </div>
    </>
  );
};

export default USVisaReforms2026;
